import PropTypes from "prop-types";
import { get, isEmpty } from "lodash";

import Text from "./show/Text";
import Email from "./show/Email";
import Image from "./show/Image";
import Url from "./show/Url";
import File from "./show/File";
import Selection from "./show/Selection";
import Relation from "./show/Relation";
import MembershipRelation from "./show/MembershipRelation";
import ContactRelation from "./show/ContactRelation";
import DateView from "./show/DateView";
import Statistics from "./show/Statistics";
import Address from "./show/Address";
import Tag from "./show/Tag";
import Html from "./show/Html";
import Headline from "./show/Headline";
import Number from "./show/Number";

const PROPERTIES = {
  // salutation and title are selections whose meaning belongs to the type
  // (tixxt/core#658, #656) — shown like any other selection
  salutation: Selection,
  title: Selection,
  address: Address,
  email: Email,
  image: Image,
  membership: MembershipRelation,
  // contacts linked at a contact (tixxt/core#654)
  contact_relation: ContactRelation,
  selection: Selection,
  text: Text,
  url: Url,
  number: Number,
  tag: Tag,
  file: File,
  date: DateView,
  statistics: Statistics,
  html: Html,
  relation: Relation,
  headline: Headline,
};

function PropertyShow({ property, options, item }) {
  const type = get(property, "type");
  const name = get(property, "name");
  const value = get(item, ["values", name]);
  const displayValue =
    get(item, ["values", "$_displayValues_", name]) ||
    get(item, ["display_values", name]);

  const Component = PROPERTIES[type];
  if (Component) {
    if (isEmpty(value) && isEmpty(displayValue)) return null;

    return (
      <Component
        property={property}
        options={options}
        value={value}
        displayValue={displayValue}
        item={value} // deprecated
      />
    );
  } else {
    return <div>Unknown property type</div>;
  }
}
PropertyShow.propTypes = {
  property: PropTypes.shape({
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  item: PropTypes.shape({
    values: PropTypes.shape({
      $_displayValues_: PropTypes.object,
      // this includes all plain values under the name as key
    }).isRequired,
    display_values: PropTypes.object,
  }),
  options: PropTypes.object,
};

export default PropertyShow;
